module.exports = __webpack_public_path__ + "img/rect-rounded.8b1d5fd1.svg";